import { useQuery } from "@tanstack/react-query";
import type { PickCompanyDto, PickQuery } from "@klantpunt/shared";
import { api } from "../../lib/api";
import { hasModule, useMe } from "../../lib/auth";

/** Keuzelijst uit het adresboek (docs/ADRESBOEK.md, stap 3); leeg zonder de module Adresboek. */
export function useDirectoryPick(query: PickQuery, enabled = true) {
  const { data: me } = useMe();
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(query)) if (v) params.set(k, String(v));
  return useQuery({
    queryKey: ["directory-pick", params.toString()],
    queryFn: () => api<PickCompanyDto[]>(`/directory/pick?${params}`),
    enabled: enabled && hasModule(me, "directory"),
    staleTime: 60_000,
  });
}

/**
 * Suggesties bij een vrij tekstveld (vrije naam in de `PartyPicker`, afgever van een document, ontvanger van een
 * deellink): bedrijven uit het adresboek, de vaste leveranciers van het gebouw eerst, plus hun personen als
 * "Naam (Bedrijf)". Standaard alleen leveranciers; `kind: undefined` geeft alle bedrijven. Koppel met `<input list={id}>`.
 */
export function DirectorySuggestions({ id, query }: { id: string; query: PickQuery }) {
  const { data } = useDirectoryPick({ kind: "supplier", ...query });
  if (!data?.length) return null;
  return (
    <datalist id={id}>
      {data.map((c) => (
        <option key={c.id} value={c.name}>
          {c.linked ? "Vaste leverancier" : c.trades.join(", ")}
        </option>
      ))}
      {data.flatMap((c) =>
        c.isInternal ? [] : c.people.map((p) => <option key={p.id} value={`${p.name} (${c.name})`} />),
      )}
    </datalist>
  );
}
